export const ProfileModalLabel = ({
  labelContent,
  className,
}: {
  labelContent: string;
  className?: string;
}) => {
  return (
    <span className={`text-[#979797] text-sm ${className}`}>
      {labelContent}
    </span>
  );
};
